module.exports = __webpack_public_path__ + "img/FMCS3.5a11a135.png";